var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zb-main" },
    [
      _c("img", {
        staticClass: "map-pic",
        attrs: { src: require("@/assets/images/schj/zb.png"), alt: "" },
      }),
      _c("img", {
        staticClass: "btm-lx",
        attrs: { src: require("@/assets/images/schj/tolx.png"), alt: "" },
        on: { click: _vm.toLx },
      }),
      _c("img", {
        staticClass: "btm-lx2",
        attrs: { src: require("@/assets/images/schj/tocg.png"), alt: "" },
        on: { click: _vm.tocg },
      }),
      _c("img", {
        staticClass: "btm-lx3",
        attrs: { src: require("@/assets/images/schj/cssk.png"), alt: "" },
        on: { click: _vm.tosk },
      }),
      _c("img", {
        staticClass: "btm-lx4",
        attrs: { src: require("@/assets/images/schj/lsys.jpg"), alt: "" },
        on: { click: _vm.toys },
      }),
      _c(
        "el-dialog",
        {
          ref: "dialog",
          attrs: {
            visible: _vm.showdialog,
            "append-to-body": true,
            width: "500px",
            top: "0",
            "custom-class": "ifr-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showdialog = $event
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: {
              src: require("@/assets/images/schj/ys-detail.jpg"),
              alt: "",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }